import { Text } from "@chakra-ui/react";
import React from "react";

const GrubTitleText = (props) => {
    if (props.isErrorText) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={300}
                fontSize="0.94rem"
                lineHeight="1.41rem"
                letterSpacing="-0.01rem"
                mt={props.mt}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isText) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={300}
                fontSize="0.94rem"
                lineHeight="1.41rem"
                letterSpacing="-0.01rem"
                mt={props.mt}
                mb={props.mb}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isCategoryText) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={300}
                fontSize={props.fontSize || "0.87rem"}
                lineHeight={"0.95rem"}
                letterSpacing="-0.02rem"
                mt={props.mt}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isDescription) {
        return (
            <Text
                fontStyle="normal"
                // fontWeight={300}
                fontSize={props.fontSize || "0.94rem"}
                lineHeight="1.17rem"
                letterSpacing="-0.02rem"
                mt={props.mt}
                display={props.display}
                fontWeight={props.fontWeight || 300}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isSelected) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={{ base: 300, md: 500 }}
                fontSize="0.75rem"
                lineHeight="0.94rem"
                letterSpacing="-0.02em"
                mt={props.mt}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isTextHome) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={400}
                fontSize={props.fontSize}
                lineHeight="1.88rem"
                letterSpacing="-0.02rem"
                mx={props.mx}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isHeading) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={500}
                fontSize="0.94rem"
                lineHeight="1.17rem"
                letterSpacing="-0.02em"
                mt={props.mt}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isInstuction) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={500}
                fontSize="0.75rem"
                lineHeight="0.94rem"
                letterSpacing="-0.02em"
                mt={props.mt}
                mb={props.mb}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isLabelText) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={props.fontWeight || 500}
                fontSize={props.fontSize || "1.13rem"}
                lineHeight="1.41rem"
                letterSpacing="-0.01rem"
                mt={props.mt}
                display={props.display}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isOrderSummaryText) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={props.fontWeight || 500}
                fontSize="0.98rem"
                lineHeight="1.17rem"
                // letterSpacing="-0.01rem"
                mt={props.mt}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isTextBold) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={500}
                fontSize={{ base: "0.87rem", md: "1.13rem" }}
                lineHeight={{ base: "0.95rem", md: "1.41rem" }}
                letterSpacing="-0.01rem"
                pt={props.pt}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isTextShow) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={props.fontWeight || 600}
                fontSize={props.fontSize || "1.5rem"}
                lineHeight={props.lineHeight || "1.88rem"}
                letterSpacing="-0.02em"
                mb={props.mb}
                mt={props.mt}
                color={props.color}
            >
                {props.name}
            </Text>
        );
    } else if (props.isModifierText) {
        return (
            <Text
                fontStyle="normal"
                fontWeight={500}
                fontSize="0.56rem"
                lineHeight={"0.70rem"}
                color="#3E3E3E"
                bg="#FFECEA"
                borderRadius="0.63rem"
                px={props.px}
                py={props.py}
                display="inline-block"
                mt={props.mt}
            >
                {props.name}
            </Text>
        );
    }
};

export default GrubTitleText;
